import { render, staticRenderFns } from "./FieldsetEmailParts.vue?vue&type=template&id=6fa881be&scoped=true"
import script from "./FieldsetEmailParts.vue?vue&type=script&lang=ts"
export * from "./FieldsetEmailParts.vue?vue&type=script&lang=ts"
import style0 from "./FieldsetEmailParts.vue?vue&type=style&index=0&id=6fa881be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa881be",
  null
  
)

export default component.exports